<template>
  <transition
    name="router-anim"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutDown"
  >
    <v-card>
      <v-card-title>
        Settlements
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details />
      </v-card-title>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="tickets"
        :pagination="pagination"
        :search="search"
        :rows-per-page-items="[10, 20, 35]"
        class="elevation-1"
      >
        <template v-slot:headers="props">
          <tr>
            <!-- <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click="toggleAll"
              ></v-checkbox>
            </th>-->
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '', header.visibility]"
              @click="changeSort(header.value)"
            >
              <v-icon size="small">arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <!-- <td>
              <v-checkbox
                :input-value="props.selected"
                primary
                hide-details
              ></v-checkbox>
          </td>-->
          <td class="text-right">{{ formatDate(props.item.ContractDate) }}</td>
          <td class="text-right">{{ props.item.ContractNumber }}</td>
          <td class="text-right">{{ props.item.Commodity }}</td>
          <td class="text-right">{{ props.item.AccountName }}</td>
          <td class="text-right">{{ props.item.AccountDescription }}</td>
          <td class="text-right">{{ props.item.ContractType }}</td>
          <td class="text-right">{{ props.item.comments }}</td>
          <td class="text-center">{{ props.item.ReviewRequestId }}</td>
          <td class="text-center">
            {{
              props.item.StatusDescription == "Approved" ? "Completed" : props.item.StatusDescription
            }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon size="small" class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon size="small" @click="deleteItem(props.item)">delete</v-icon>
          </td>
        </template>
        <template v-slot:no-data>Sorry, nothing to display here.</template>
        Your search for "{{ search }}" found no results.
      </v-data-table>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-col col="12" sm="6" md="7">
                  <span class="text-grey">Contract Number</span>
                  <br />
                  <span class="text-grey">Account Name</span>
                  <br />
                  <span class="text-grey">Account Description</span>
                  <br />
                  <span class="text-grey">Contract Date</span>
                  <br />
                  <span class="text-grey">Type</span>
                  <br />
                </v-col>
                <v-col col="12" sm="6" md="7">
                  <span class="text-grey">{{ editedItem.ContractNumber }}</span>
                  <br />
                  <span class="text-grey">{{ editedItem.AccountName }}</span>
                  <br />
                  <span class="text-grey">{{ editedItem.AccountDescription }}</span>
                  <br />
                  <span class="text-grey">{{ editedItem.ContractDate }}</span>
                  <br />
                  <span class="text-grey">{{ editedItem.ContractType }}</span>
                  <br />
                </v-col>
                <v-spacer />
                <v-divider dark light />
                <v-col col="12" sm="12" md="12">
                  <v-textarea label="Comments" v-model="editedItem.comments" />
                </v-col>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-layout wrap>
              <v-col col="12" sm="12" md="12">
                <v-btn
                  size="small"
                  variant="outlined"
                  color="green-darken-2"
                  @click="done(editedItem.RequestUser)"
                >
                  Done
                  <v-icon end dark>check_circle</v-icon>
                </v-btn>
                <v-btn
                  size="small"
                  variant="outlined"
                  color="green-darken-2"
                  @click="decline(editedItem.RequestUser)"
                >
                  Decline
                  <v-icon end dark>delete_forever</v-icon>
                </v-btn>
                <v-btn size="small" variant="outlined" color="green-darken-2" @click="close">Cancel</v-btn>
              </v-col>
              <v-col col="12" sm="12" md="12">
                <v-progress-linear
                  :indeterminate="true"
                  height="5"
                  color="green"
                  v-if="actioninProgress"
                />
              </v-col>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDeclineComments" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Reason of Rejection</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-col col="12" sm="12" md="12">
                  <v-textarea label="Comments" v-model="editedItem.DeclineComments" />
                </v-col>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-layout wrap>
              <v-col col="12" sm="12" md="12">
                <v-btn
                  size="small"
                  variant="outlined"
                  color="green-darken-2"
                  @click="confirmDecline(editedItem.RequestUser)"
                >
                  Confirm
                  <v-icon end dark>delete_forever</v-icon>
                </v-btn>
                <v-btn
                  size="small"
                  variant="outlined"
                  color="green-darken-2"
                  @click="cancelDecline">Cancel</v-btn>
              </v-col>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSuccess" width="500">
        <v-card>
          <v-spacer />
          <v-card-text>{{errorOrsuccessMessage}}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" variant="text" @click="dialogSuccess = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </transition>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from "@/services/data-service";
const dataService = new DataService();
import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
  name: "tickets",
  props: ["id"],
  loading: true,
  data: () => ({
    dialog: false,
    dialogDeclineComments: false,
    dialogSuccess: false,
    actioninProgress: false,
    errorOrsuccessMessage: "",
    editedIndex: -1,
    editedItem: {
      ticketnumber: "0000123",
      account: "A Growsem",
      accountDescription: "Adam Growsem",
      shipfrom: "Adam Growsem",
      location: "Central Depot",
      netweight: "56,000.00 LB",
      netquantity: "76,000.00 LB",
      product: "01- Yellow Corn"
    },
    defaultItem: {
      ticketnumber: "0000123",
      account: "A Growsem",
      accountDescription: "Adam Growsem",
      shipfrom: "Adam Growsem",
      location: "Central Depot",
      netweight: "56,000.00 LB",
      netquantity: "76,000.00 LB",
      product: "01- Yellow Corn"
    },
    search: "",
    pagination: {
      sortBy: "TicketNumber"
    },
    selected: [],
    headers: [
      { text: "Contract Date", value: "ContractDate", width: "1%" },
      { text: "Contract Number", value: "ContractNumber", width: "1%" },
      { text: "Commodity", value: "Commodity", width: "1%" },
      { text: "Account", value: "AccountName", width: "1%" },
      { text: "Description", value: "AccountDescription", width: "1%" },
      { text: "Type", value: "ContractType", width: "1%" },
      { text: "Comments", value: "comments", width: "1%" },
      {
        text: "Request No",
        value: "ReviewRequestId",
        align: "left",
        width: "1%"
      },
      {
        text: "Request Status",
        value: "ReviewStatusId",
        align: "left",
        width: "1%"
      },
      { text: "", value: "ContractDate", align: "left" }
      // { text: "Ship From", value: "shipfrom" },
      // { text: "Location", value: "location" },
      // { text: "Weight (Net)", value: "netweight" },
      // { text: "Quantity (Net) ", value: "netquantity" },
      // { text: "Product", value: "product" }
    ],
    tickets: []
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Actions";
    },
    updateTickets() {
      this.tickets = this.$store.getters.getUserInfo;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDeclineComments() {
      val || this.cancelDecline();
    },
    $route(to, from) {
      console.log(to.params.id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    next();
  },

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDataFromServer();
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.tickets.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.tickets.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    cancelDecline() {
      this.dialogDeclineComments = false;
    },
    done(email) {
      this.actioninProgress = true;
      email = email.replace("@", "_");
      var userInfo = this.$store.getters.getUserInfo;
      dataService.doneRequest(
        this.editedItem.ReviewRequestId,
        userInfo.userEmail,
        this.editedItem.comments,
        data => {
          if (!data) {
            this.actioninProgress = false;
            this.errorOrsuccessMessage = "Error occured";
            this.dialogSuccess = true;
          } else {
            dataService.sendMessage(
              email,
              "Request Notifcation",
              "Your request has been completed.",
              this.editedItem.AgrisNameAddressID,
              this.editedItem.SQLID
            );
            this.actioninProgress = false;
            this.initialize();
            this.errorOrsuccessMessage = "Request accepted successfully.";
            this.dialogSuccess = true;
            this.close();
          }
        }
      );
    },
    decline(email) {
      this.dialogDeclineComments = true;
    },
    confirmDecline(email) {
      this.cancelDecline();
      this.actioninProgress = true;
      email = email.replace("@", "_");
      var userInfo = this.$store.getters.getUserInfo;
      dataService.declineRequest(
        this.editedItem.ReviewRequestId,
        userInfo.userEmail,
        this.editedItem.comments,
        data => {
          if (!data) {
            this.actioninProgress = false;
            this.errorOrsuccessMessage = "Error occured";
            this.dialogSuccess = true;
          } else {
            dataService.sendMessage(
              email,
              "Request Notifcation",
              "Unfortunately, your request has been rejected.",
              this.editedItem.AgrisNameAddressID,
              this.editedItem.SQLID
            );
            this.actioninProgress = false;
            this.initialize();
            this.errorOrsuccessMessage = "Request declined successfully.";
            this.dialogSuccess = true;
            this.close();
          }
        }
      );
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MMM Do YY");
      }
    },
    getDataFromServer() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        let items = [];
        dataService.getActionsListRequest("Settlements", _tickets => {
          items = _tickets.map(r =>
            Object.assign(
              {},
              r,
              r.AdditionalInfo,
              r.AdditionalInfo.ticket,
              (r.AdditionalInfo.ticket || {})._propertyValues
            )
          );
          console.log(items);
          this.tickets = items;
          this.$store.commit("updateTickets", this.tickets);
          const total = items.length;

          if (this.pagination.sortBy) {
            items = items.sort((a, b) => {
              const sortA = a[sortBy];
              const sortB = b[sortBy];

              if (descending) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }

          if (rowsPerPage > 0) {
            items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
          }

          setTimeout(() => {
            this.loading = false;
            resolve({
              items,
              total
            });
          }, 1000);
        });
      });
    }
  }
};
</script>

<style scoped>
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
